import React from 'react';
import {HashLink as Link} from 'react-router-hash-link';
import locales from '../../locales/locales';
const CTA=({subText,globalSettings})=>{
  return (
    <div className='bg-purple-900 py-12'>
      <div className='w-full px-4 sm:px-6 lg:px-8 text-center'>
        <h2 className='text-3xl font-bold text-white mb-4'>
          {locales.ctaHeading[globalSettings.lang]}
        </h2>
        <p className='text-xl text-purple-200 mb-8 max-w-3xl mx-auto'>{subText}</p>
        <Link to={`/${globalSettings.lang}/translator`}>
          <button className='bg-purple-600 hover:bg-purple-800 text-white px-8 py-4 rounded-lg text-lg font-medium'>
            {locales.ctaButton[globalSettings.lang]}
          </button>
        </Link>
      </div>
    </div>
  );
};
export default CTA;

